/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyTrxInfo } from './EvmDailyTrxInfo';

export type EvmHomeTotalDepositInfo = {
    TDCNT: string;
    CNGP: string;
    TRXHTP: EvmHomeTotalDepositInfo.TRXHTP;
    DTRXLIST: Array<EvmDailyTrxInfo>;
};

export namespace EvmHomeTotalDepositInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

